import * as Sentry from '@sentry/react'

export const initSentry = () => {
  const environment = process.env.NODE_ENV || 'development'
  const dsn = process.env.SENTRY_DSN

  if (!dsn) {
    console.warn(
      'Sentry DSN is not configured. Sentry will not be initialized.',
    )
    return
  }

  Sentry.init({
    dsn,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Mask all text and inputs for privacy
        maskAllText: true,
        maskAllInputs: true,
      }),
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    ],
    // Enable logs to be sent to Sentry
    enableLogs: true,
    // Session Replay sampling
    replaysSessionSampleRate: 0.1, // Capture 10% of all sessions
    replaysOnErrorSampleRate: 1.0, // Capture 100% of sessions with errors
    // Performance Monitoring
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    // Release tracking
    release: process.env.APP_VERSION,
    // Set user context
    beforeSend(event, hint) {
      // Filter out certain errors if needed
      if (environment === 'development') {
        console.log('Sentry Event:', event, hint)
      }

      // Add user context from Telegram Mini App
      if (window.Telegram?.WebApp?.initDataUnsafe?.user) {
        const tgUser = window.Telegram.WebApp.initDataUnsafe.user
        event.user = {
          id: String(tgUser.id),
          username: tgUser.username,
          // Add more user data if available
        }
      }

      return event
    },
    // Ignore certain errors
    ignoreErrors: [
      // Browser extensions
      'top.GLOBALS',
      // Facebook related errors
      'fb_xd_fragment',
      // IE specific errors
      'Non-Error promise rejection captured',
      // Network errors that are expected
      'Network request failed',
      'NetworkError',
      'Failed to fetch',
    ],
  })
}
